import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-slate-950 text-center text-white" aria-label="Limited time offer" data-id="element-224" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-amber-400" aria-hidden="true" data-id="element-225" data-mp="36binplrzjpfg" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-226" data-mp="31izawr14gybp">
        <p className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[.16em] text-amber-400" data-id="element-227" data-mp="31h4qddtrj885">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-228" data-mp="3b910jn94iosq" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-229" data-mp="3p8tppe504wyl" />
        <p className="mt-7 font-bold text-slate-300" data-id="element-230" data-mp="3p7sb4zos1sc4">After that the price increases and never drops again.</p>
      </div>
      <div className="h-1 w-full bg-amber-400" aria-hidden="true" data-id="element-231" data-mp="3l7qamtus34yf" />
    </section>;
}